import HttpService from "./http.service";

class InvoicesService extends HttpService {

  list = (params) => this.get("cons_report_data/group_list_invoice", params);

  labelsList = (params) => this.get("cons_report_data/label_list_invoice", params);

  create = (data) => this.post(`invoice/store`, data);

  update = (id, data) => this.patch(`invoice/${id}`, data);

  reportList = (params) => this.get("invoice/list", params);

  // show = (id) => this.get(`suppliers/job/${id}`);

}

export default new InvoicesService();
